import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';

@Component({
  selector: 'app-merchant-dashboard',
  templateUrl: './merchant-dashboard.component.html',
  styleUrls: ['./merchant-dashboard.component.scss']
})
export class MerchantDashboardComponent implements OnInit {


  merchant:any;

  merchantId:any;


  dashboard:any = {

    services:0,

    bookings:0,

    revenue:0,

    rating:'--',

    acceptedBookings:0,

    pendingBookings:0,

    rejectedBookings:0,

    blockedDates:0,

    upcomingBookings:[]

  };



  constructor(
    private apiService:ApiServiceService,
    private router:Router
  ){}



  ngOnInit(): void {


    this.merchantId =
    localStorage.getItem('merchantId');


    if(this.merchantId){

      this.getMerchantProfile();

      this.loadDashboard();

    }

  }




  getMerchantProfile(){


    this.apiService
    .getMerchantProfile(this.merchantId)
    .subscribe({

      next:(res)=>{

        this.merchant=res.data;

      },

      error:(err)=>{

        console.log(err);

      }

    });


  }





  loadDashboard(){


    // SERVICES

    this.apiService
    .getMerchantServices(this.merchantId)
    .subscribe({

      next:(res:any)=>{


        if(res.data){

          this.dashboard.services =
          res.data.length;

        }


      }

    });







    // BOOKINGS


    this.apiService
    .getMerchantBookings(this.merchantId)
    .subscribe({

      next:(res:any)=>{


        if(res.data){


          const bookings=res.data;


          this.dashboard.bookings =
          bookings.length;



          this.dashboard.acceptedBookings =
          bookings.filter(
            (x:any)=>
            x.booking_status==="Confirmed"
          ).length;



          this.dashboard.pendingBookings =
          bookings.filter(
            (x:any)=>
            x.booking_status==="Pending"
          ).length;



          this.dashboard.rejectedBookings =
          bookings.filter(
            (x:any)=>
            x.booking_status==="Rejected"
          ).length;



          this.dashboard.upcomingBookings =
          bookings.filter(
            (x:any)=>
            x.booking_status==="Confirmed"
          ).slice(0,3);


        }


      }

    });








    // REVENUE


    this.apiService
    .getTotalRevenue(this.merchantId)
    .subscribe({

      next:(res:any)=>{


        if(res){

          this.dashboard.revenue =
          res.pending || 0;

        }


      }


    });








    // BLOCKED DATES


    this.apiService
    .getBlockedDates(this.merchantId)
    .subscribe({

      next:(res:any)=>{


        if(res.data){

          this.dashboard.blockedDates =
          res.data.length;

        }


      }


    });


  }







  formatMoney(value:number){

    return value?.toLocaleString('en-IN');

  }







  logout(){


    localStorage.removeItem('merchantToken');

    localStorage.removeItem('merchantId');

    localStorage.removeItem('merchantName');


    this.router.navigate([
      '/merchant/login'
    ]);


  }



}